export default {
  forgot_password_submit: {
    title: 'Reset password',
    submit_complete: 'Sent successfully',
    password_reset: 'Password has been reset',
  },
}
